<template>
  <div class="side-menu l_border">
    <b-nav vertical>
      <item-user-info />
      <item-password-change />
      <item-data-init />
      <item-site-config />
      <item-api-test
        v-if="isDev"
      />
      <item-logout />
    </b-nav>

    <div class="vertical-line">
    </div>
  </div>
</template>

<script>
import ItemUserInfo from './Item/UserInfo'
import ItemPasswordChange from './Item/PasswordChange'
import ItemDataInit from './Item/DataInit'
import ItemSiteConfig from './Item/SiteConfig'
import ItemApiTest from './Item/ApiTest'
import ItemLogout from './Item/Logout'

export default {
  components: {
    ItemUserInfo,
    ItemPasswordChange,
    ItemDataInit,
    ItemSiteConfig,
    ItemApiTest,
    ItemLogout
  },

  computed: {
    isDev () {
      return process.env.NODE_ENV === 'development'
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 480px) {
  .side-menu {
    display: flex;
    justify-content: center;
    padding-bottom: 40px;
    margin-bottom: 30px;
    width: 90%;
  }
}

@media screen and (min-width: 480px) {
  .l_border {
    border-right: 1px solid silver;
    margin-right: 50px;
  }
}

@media screen and (max-width: 480px) {
  .l_border {
    border-bottom: 1px solid silver;
  }
}
</style>
